document.addEventListener('DOMContentLoaded', function () {
    const companySelectField = document.querySelector("#filter-company-select");
    const locationSelectField = document.querySelector("#filter-locations-select");
    const typeSelectField = document.querySelector("#filter-types-select");

    const companyHiddenField = document.querySelector('#filter-companies');
    const locationHiddenField = document.querySelector('#filter-locations');
    const typeHiddenField = document.querySelector('#filter-types');

    const tagCloud = document.querySelector('#tag-cloud');

    // ---------- Helpers ----------

    function getValues(field) {
        if (!field.value) return [];
        return field.value.split(',').filter(v => v.trim() !== '');
    }

    function setValues(field, values) {
        field.value = values.join(',');
    }

    function addValue(field, value) {
        let values = getValues(field);
        if (!values.includes(value)) {
            values.push(value);
            setValues(field, values);
        }
    }

    function removeValue(field, value) {
        let values = getValues(field);
        values = values.filter(v => v !== value);
        setValues(field, values);
    }

    function getLabelFromSelect(select, value) {
        const option = select.querySelector(`option[value="${value}"]`);
        return option ? option.textContent : value;
    }

    function createTag(type, value, label) {
        const tag = document.createElement('span');
        tag.classList.add('tag', 'tag--filter', `tag--${type}`);
        tag.dataset.type = type;
        tag.dataset.value = value;

        tag.innerHTML = `
            <span class="tag__label">${label}</span>
            <button class="tag__remove" type="button">&times;</button>
        `;

        tag.querySelector('.tag__remove').addEventListener('click', function () {
            // remove from hidden field
            if (type === 'company') removeValue(companyHiddenField, value);
            if (type === 'location') removeValue(locationHiddenField, value);
            if (type === 'type') removeValue(typeHiddenField, value);

            tag.remove();
        });

        return tag;
    }

    function renderTags() {
        tagCloud.innerHTML = '';

        getValues(companyHiddenField).forEach(value => {
            const label = getLabelFromSelect(companySelectField, value);
            tagCloud.appendChild(createTag('company', value, label));
        });

        getValues(locationHiddenField).forEach(value => {
            const label = getLabelFromSelect(locationSelectField, value);
            tagCloud.appendChild(createTag('location', value, label));
        });

        getValues(typeHiddenField).forEach(value => {
            const label = getLabelFromSelect(typeSelectField, value);
            tagCloud.appendChild(createTag('type', value, label));
        });
    }

    // ---------- Events ----------

    companySelectField.addEventListener("change", function () {
        const value = companySelectField.value;
        if (!value) return;

        addValue(companyHiddenField, value);
        renderTags();
    });

    locationSelectField.addEventListener("change", function () {
        const value = locationSelectField.value;
        if (!value) return;

        addValue(locationHiddenField, value);
        renderTags();
    });

    typeSelectField.addEventListener("change", function () {
        const value = typeSelectField.value;
        if (!value) return;

        addValue(typeHiddenField, value);
        renderTags();
    });

    // ---------- Initial Load ----------

    renderTags();
});